export default __webpack_public_path__ + "static/media/pallet.9224c123.svg";